import * as actionTypes from "../actionTypes/Index";
import { paiyaConfigInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...paiyaConfigInitialState };

export default function paiyaConfigReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_PAIYA_TYPES_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isPaiyaTypesFetched: false,
        paiyaTypesList: [],
      });
    }
    case actionTypes.GET_PAIYA_TYPES_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isPaiyaTypesFetched: true,
        // .slice is used here to convert action.payload into an array if it is not
        paiyaTypesList: (action.payload! as Array<any>).slice(),
      });
    }
    case actionTypes.GET_PAIYA_TYPES_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isPaiyaTypesFetched: false,
        paiyaTypesList: null,
      });
    }
    case actionTypes.CREATE_PAIYA_STORE_CONFIG_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        paiyaConfig: null,
        // isPaiyaConfigAdded: true,
        isStoreCsvLoading: true,
        isStoreCsvUploaded: false,
        isStoreCsvError: false,
      });
    }
    case actionTypes.CREATE_PAIYA_STORE_CONFIG_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        paiyaConfig: action.payload,
        // isPaiyaConfigAdded: true,
        isStoreCsvLoading: false,
        isStoreCsvUploaded: true,
        isStoreCsvError: false,
        storeCsvError: null,
      });
    }
    case actionTypes.CREATE_PAIYA_STORE_CONFIG_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        paiyaConfig: null,
        // isPaiyaConfigAdded: false,
        isStoreCsvLoading: false,
        isStoreCsvUploaded: true,
        isStoreCsvError: true,
        storeCsvError: action.error,
        // error: action.error,
      });
    }
    case actionTypes.CREATE_PAIYA_GIFT_CONFIG_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        paiyaConfig: null,
        // isPaiyaConfigAdded: true,
        // isGiftUploaded: false,
        isGiftCsvLoading: true,
        isGiftCsvUploaded: false,
        isGiftCsvError: false,
      });
    }
    case actionTypes.CREATE_PAIYA_GIFT_CONFIG_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        paiyaConfig: action.payload,
        // isPaiyaConfigAdded: true,
        isGiftCsvLoading: false,
        isGiftCsvUploaded: true,
        isGiftCsvError: false,
        giftCsvError: null,
        // error: action.error,
      });
    }
    case actionTypes.CREATE_PAIYA_GIFT_CONFIG_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        paiyaConfig: null,
        // isPaiyaConfigAdded: false,
        isGiftCsvLoading: false,
        isGiftCsvUploaded: true,
        isGiftCsvError: true,
        error: action.error,
        giftCsvError: action.error,
      });
    }
    case actionTypes.CREATE_PAIYA_MOV_STATUS_CONFIG_INIT: {
      return Object.assign({}, state, {
        // isLoading: true,
        // isError: false,
        // error: null,
        // paiyaConfig: null,
        isMovStatusLoading: true,
        // isPaiyaConfigAdded: false,
        // isGiftUploaded: false,
        // isGiftCsvLoading: true,
        // isGiftCsvUploaded: false,
        // isGiftCsvError: false,
      });
    }
    case actionTypes.CREATE_PAIYA_MOV_STATUS_CONFIG_SUCCESS: {
      return Object.assign({}, state, {
        // isLoading: false,
        // isError: false,
        // paiyaConfig: action.payload,
        // isPaiyaConfigAdded: true,
        // isGiftCsvLoading: false,
        // isGiftCsvUploaded: true,
        // isGiftCsvError: false,
        movStatusError: null,
        isMovStatusLoading: false
        // error: action.error,
      });
    }
    case actionTypes.CREATE_PAIYA_MOV_STATUS_CONFIG_FAIL: {
      return Object.assign({}, state, {
        // isLoading: false,
        // isError: true,
        // paiyaConfig: null,
        // isPaiyaConfigAdded: false,
        // isGiftCsvLoading: false,
        // isGiftCsvUploaded: true,
        // isGiftCsvError: true,
        // error: action.error,
        movStatusError: action.error,
        isMovStatusLoading: false,
      });
    }
    case actionTypes.GET_PAIYA_CONFIG_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isPaiyaConfigFetch: false,
        paiyaConfig: null,
      });
    }
    case actionTypes.GET_PAIYA_CONFIG_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isPaiyaConfigFetch: true,
        // .slice is used here to convert action.payload into an array if it is not
        paiyaConfig: action.payload,
      });
    }
    case actionTypes.GET_PAIYA_CONFIG_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isPaiyaConfigFetch: false,
        paiyaConfig: null,
      });
    }
    default:
      return state;
  }
}
